import { Kinetic, Label } from "@/components/motion";
import { motion } from "framer-motion";
import { EASE } from "@/components/motion";

export default function PageHero({ image, label, titleLines, sub, tall = false }) {
  return (
    <section
      data-testid="page-hero"
      className={`relative w-full overflow-hidden bg-ink ${tall ? "h-[92vh] min-h-[560px]" : "h-[68vh] min-h-[480px]"}`}
    >
      <motion.img
        src={image}
        alt={titleLines.join(" ")}
        className="absolute inset-0 h-full w-full object-cover"
        initial={{ scale: 1.12 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2.4, ease: EASE }}
      />
      <div className="absolute inset-0 bg-black/45" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/20" />
      <div className="relative z-10 mx-auto flex h-full max-w-[1600px] flex-col justify-end px-6 pb-16 lg:px-12 lg:pb-24">
        {label && (
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15, ease: EASE }}
          >
            <Label>{label}</Label>
          </motion.div>
        )}
        <h1 className="mt-6 font-serif text-5xl font-light leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-8xl">
          <Kinetic lines={titleLines} />
        </h1>
        {sub && (
          <motion.p
            className="mt-6 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.7, ease: EASE }}
          >
            {sub}
          </motion.p>
        )}
      </div>
    </section>
  );
}
